import React, { FC } from "react";
import { ApplicationProductEnum } from "enums/application-product.enum";
import { PremiumFeatureBlock } from "routes/dashboard/components/PremiumFeatureBlock/PremiumFeatureBlock";
import { UserAccountStore } from "store/UserAccounts/UserAccount/UserAccount.store";
import { observer } from "mobx-react";
import { DevelopersConfig } from "./DevelopersConfig";
import { DevelopersSplashScreen } from "./DevelopersSplashScreen/DevelopersSplashScreen";

interface IProps {
  accountStore: UserAccountStore;
}

export const DevelopersConfigGuard: FC<IProps> = observer(
  ({ accountStore }) => {
    return (
      <PremiumFeatureBlock
        productId={ApplicationProductEnum.DEVELOPERS_TAB}
        render={isEnabled => <DevelopersConfig accountStore={accountStore} />}
        alternativeRender={() => (
          <DevelopersSplashScreen accountStore={accountStore} />
        )}
      />
    );
  }
);
